import React, { useEffect, useState } from "react";
import {
  Button,
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  MenuItem,
  Autocomplete,
  Grid,
  Paper,
} from "@mui/material";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { FormikProvider, useFormik } from "formik";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  AGREGAR_CAT_EGRESO,
  OBTENER_CAT_EGRESOS,
} from "../../../../graphql/egresos";
import * as Yup from "yup";

import Iconify from "../../../../components/Iconify";
const FrmAgregarConceptoEgreso = ({
  setOpenDialog,
  setOpenSnackBar,
  setErrorGraph,
}) => {
  const [agregarCategoriaEgresos] = useMutation(AGREGAR_CAT_EGRESO, {
    update(cache, { data: { agregarCategoriaEgresos } }) {
      const { obtenerCategoriasEgresos } = cache.readQuery({
        query: OBTENER_CAT_EGRESOS,
      });
      cache.writeQuery({
        query: OBTENER_CAT_EGRESOS,
        data: {
          obtenerCategoriasEgresos: [
            ...obtenerCategoriasEgresos,
            agregarCategoriaEgresos,
          ],
        },
      });
    },
  });
  //Formik

  const formik = useFormik({
    initialValues: {
      clave: "",
      descripcion: "",
    },

    validationSchema: Yup.object({
      clave: Yup.string().required("La clave es requerida"),
    }),
    onSubmit: async (inputdata) => {
      try {
        const result = await agregarCategoriaEgresos({
          variables: {
            input: {
              clave: inputdata.clave,
              descripcion: inputdata.descripcion,
            },
          },
        });
        setOpenSnackBar(true);
        setErrorGraph({
          mensaje: result.data.agregarCategoriaEgresos,
          severity: "success",
        });
        formik.resetForm();
      } catch (error) {
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: error.message, severity: "error" });
      }
    },
  });
  const handleOpenDialog = () => {
    setOpenDialog(false);
    //setOpenSnackBar(true);
  };
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Paper style={{ padding: 10 }}>
          <Grid container alignItems="flex-start" spacing={3}>
            <Grid item xs={12}>
              <TextField
                id="clave"
                label="Clave de Egreso"
                variant="standard"
                value={formik.values.clave}
                onChange={formik.handleChange}
                fullWidth="true"
              />
              {formik.errors.clave}
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="descripcion"
                label="Descripción del Egreso"
                value={formik.values.descripcion}
                onChange={formik.handleChange}
                variant="standard"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <Button
                type="submit"
                startIcon={<Iconify icon="eva:save-outline" />}
              >
                Guardar
              </Button>
              <Button
                onClick={() => handleOpenDialog()}
                color="error"
                startIcon={<Iconify icon="eva:close-outline" />}
              >
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </form>
    </>
  );
};

export default FrmAgregarConceptoEgreso;
